// mds-dojo — dijit/form/ComboBox — FAITHFUL port of references/dijit/form/ComboBox.js.
// Codemod pipeline; declare from the faithful runtime. No adaptations beyond import rewrites.
// Auto-completing text box.
import declare from '../../dojo/_base/declare-runtime'; // declare
import ValidationTextBox from './ValidationTextBox';
import ComboBoxMixin from './ComboBoxMixin';

export default declare("dijit.form.ComboBox", [ValidationTextBox, ComboBoxMixin], {
	// summary:
	//		Auto-completing text box
	//
	// description:
	//		The drop down box's values are populated from an class called
	//		a data provider, which returns a list of values based on the characters
	//		that the user has typed into the input box.
	//		If OPTION tags are used as the data provider via markup,
	//		then the OPTION tag's child text node is used as the widget value
	//		when selected.  The OPTION tag's value attribute is ignored.
	//		To set the default value when using OPTION tags, specify the selected
	//		attribute on 1 of the child OPTION tags.
	//
	//		Some of the options to the ComboBox are actually arguments to the data
	//		provider.
});
